import { SelectStyleConfig } from '../types';

export const styleConfig: SelectStyleConfig = {
  baseStyle: {
    field: {
      color: 'grey.900',
      _disabled: {
        borderColor: 'grey.300',
        bg: 'grey.50',
        _hover: {
          borderColor: 'grey.300',
        },
      },
    },
  },
  sizes: {
    default: {
      field: {
        height: '12',
        width: '100%',
        border: '0.1',
        borderRadius: 'sm-md',
        borderColor: 'grey.400',
        bg: 'white',
        py: '3',
        pl: '4',
        pr: '2.5',
      },
    },
  },
  variants: {
    default: {
      field: {
        _hover: {
          borderColor: 'blue.300',
        },
        _focusVisible: {
          borderColor: 'blue.500',
        },
      },
    },
    success: {
      field: {
        borderColor: 'green.500',
        _hover: {
          borderColor: 'green.500',
        },
        _focusVisible: {
          borderColor: 'blue.500',
        },
      },
    },
    warning: {
      field: {
        borderColor: 'orange.500',
        _hover: {
          borderColor: 'orange.500',
        },
        _focusVisible: {
          borderColor: 'blue.500',
        },
      },
    },
    error: {
      field: {
        borderColor: 'red.500',
        _hover: {
          borderColor: 'red.500',
        },
        _focusVisible: {
          borderColor: 'blue.500',
        },
      },
    },
  },
  defaultProps: {
    variant: 'default',
    size: 'default',
  },
};
